import React from 'react'
import { periodEndDate } from './timeHorizon.js'

export function GoalStatsStrip({ rollup, timeHorizon }) {
  if (!rollup) return null

  const parts = []

  if (rollup.total > 0) {
    const onTrack = rollup.onTrack + rollup.done
    parts.push(`${onTrack} of ${rollup.total} sub-goals on track`)
  }

  const endDate = periodEndDate(timeHorizon)
  if (endDate) {
    const days = Math.ceil((endDate - Date.now()) / 86400000)
    if (days > 0) {
      parts.push(`${days}d remaining`)
    } else if (days === 0) {
      parts.push('Due today')
    } else {
      parts.push(`${Math.abs(days)}d overdue`)
    }
  }

  if (parts.length === 0) return null

  return (
    <div style={styles.strip}>
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span style={styles.dot}>&middot;</span>}
          <span style={styles.stat}>{part}</span>
        </React.Fragment>
      ))}
    </div>
  )
}

const styles = {
  strip: { display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' },
  stat: { fontSize: '11px', color: 'var(--text-secondary)' },
  dot: { fontSize: '11px', color: 'var(--text-secondary)' },
}
